export default __webpack_public_path__ + "static/media/linkedinIcon.1f962e52.svg";